export default __webpack_public_path__ + "static/media/yella.fe5c62a8.png";